import { createElement, memo, useState, useEffect, useCallback, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import TextInput from '@hfe/max-textinput';
import Icon from '@max/leez-icon';
import { searchCities } from '../cityUtil';
import './index.scss';
function SearchArea(props) {
    const { cities, currentCityName, onClose, onSearchChange, onSelectCity, searchKeyword } = props;
    // 本地维护输入值，避免受控模式下 IME 组合被 React 的 value 覆盖打断
    const [localValue, setLocalValue] = useState(searchKeyword);
    const isComposingRef = useRef(false);
    // 同步外部 searchKeyword 变化（如清空场景）
    useEffect(() => {
        if (searchKeyword !== localValue && !isComposingRef.current) {
            setLocalValue(searchKeyword);
        }
    }, [searchKeyword]);
    const suggestList = localValue ? searchCities(cities, localValue) : [];
    const handleChange = useCallback((value) => {
        setLocalValue(value);
        // 只在非 IME 组合期间同步给父组件
        if (!isComposingRef.current) {
            onSearchChange(value);
        }
    }, [onSearchChange]);
    // 追踪 IME 组合状态：compositionstart 时设为 true，compositionend 时设为 false
    // compositionend 后需要把最终值同步给父组件
    const handleInput = useCallback((e) => {
        const composing = !!e?.originalEvent?.isComposing;
        isComposingRef.current = composing;
        // IME 组合刚结束，把最终值同步给父组件
        if (!composing && e?.originalEvent) {
            const finalValue = e.originalEvent.target?.value ?? e.value;
            onSearchChange(finalValue);
        }
    }, [onSearchChange]);
    return <View className="cfe-search-area">
      <View className="cfe-search-row">
        <View className="cfe-search-input-wrap">
          <Icon name='search-line-regular' type='title1' className='demo-icon-icon' iconFontType='meishi' color='#999999'/>
          <TextInput className="cfe-search-input" placeholder="城市/区县" placeholderColor="#999999" value={localValue} onChangeText={handleChange} onInput={handleInput}/>
        </View>
        <View className="cfe-search-close-wrap" onClick={onClose}>
          <Text className="cfe-search-close">✕</Text>
        </View>
      </View>

      {searchKeyword !== '' && suggestList.length > 0 && <View className="cfe-suggest-list">
          {suggestList.map(city => <View key={String(city.id)} className="cfe-suggest-item" onClick={() => onSelectCity(city)}>
              <Text className="cfe-suggest-text">{city.name}</Text>
              <View className="cfe-suggest-divider"/>
            </View>)}
        </View>}

      {searchKeyword !== '' && suggestList.length === 0 && <View className="cfe-not-found">
          <Text className="cfe-not-found-text">未找到相关城市/区县</Text>
        </View>}

      {searchKeyword === '' && currentCityName && <View className="cfe-current-city-row">
          <Text className="cfe-current-city-text">{`当前城市: ${currentCityName}`}</Text>
          <View className="cfe-current-city-divider"/>
        </View>}
    </View>;
}
export default memo(SearchArea);
